import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { CargoDriversView } from "src/components/views/erp/warehouse/masterData/cargoDrivers/CargoDriversView.tsx";

export const Route = createFileRoute("/_authenticated/_shell/erp/warehouse/cargoDrivers")({
	staticData: { title: i18n.t("cargo_drivers"), legacyViewKey: "cargoDriversDataGrid" },
	component: RouteComponent,
});

function RouteComponent() {
	return <CargoDriversView />;
}
